// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import { getAuthUser, yandexGeoCodeApiKey } from './config'
import VueApollo from 'vue-apollo'
import apolloClient from './apolloClient'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueTruncate from 'vue-truncate-filter'
import YmapPlugin from 'vue-yandex-maps'
import { dropdown, datepicker } from 'vue-strap'
import datepickerGetDateRangeMonkeyPath from './helpers/datepickerGetDateRangeMonkeyPath'
import './filters' // Vue filters
import BootstrapVue from 'bootstrap-vue'
import VueEcho from 'vue-echo'
import EchoClient from './echoClient'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(VueAxios, axios)
Vue.use(VueScrollTo)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueTruncate)
Vue.use(YmapPlugin, {
  apiKey: yandexGeoCodeApiKey,
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
})
Vue.use(mavonEditor)
Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// Global components
Vue.component('loading', require('./components/Loading.vue'))
require('moment/locale/ru')
require('vue-strap/dist/vue-strap-lang.js')
Vue.component('dropdown', dropdown)
datepicker.methods.getDateRange = datepickerGetDateRangeMonkeyPath
Vue.component('datepicker', datepicker)

/**
 * remove after update bootstrap-bue beta-10
 * @see https://github.com/bootstrap-vue/bootstrap-vue/issues/1201#issuecomment-337663138
 */
let originalVueComponent = Vue.component
Vue.component = function (name, definition) {
  if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' ||
    name === 'bCheckGroup' || name === 'bFormRadioGroup') {
    definition.components = {bFormCheckbox: definition.components[0]}
  }
  originalVueComponent.apply(this, [name, definition])
}
Vue.use(BootstrapVue)
Vue.component = originalVueComponent

router.beforeEach((to, from, next) => {
  document.body.classList.remove('sidebar-mobile-show')
  if (to.meta.requiresAuth) {
    const authUser = getAuthUser()
    if (authUser && authUser.access_token) {
      if (to.fullPath === '/') {
        next({name: 'Dashboard'})
      } else {
        next()
      }
    } else {
      next({name: 'Auth'})
    }
  }
  if (to.meta.checkLogin) {
    const authUser = getAuthUser()

    if (authUser && authUser.access_token) {
      next({name: 'Dashboard'})
    } else {
      next()
    }
  }
  next()
})
Vue.use(VueEcho, EchoClient)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  apolloProvider,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js